import { render } from "./Tag.vue?vue&type=template&id=0d6060e5"
import script from "./Tag.vue?vue&type=script&lang=js"
export * from "./Tag.vue?vue&type=script&lang=js"
script.render = render

export default script